/**
 * Voces de ElevenLabs que se pueden ELEGIR en Marca y Personajes.
 * Son las 26 del manifest del nodo eleV2 en el servidor (el enum que valida
 * configure_node) y las mismas que tiene el servicio de muestras: cualquiera
 * de estas se puede aplicar sola a los nodos y escuchar con ▶ sin gastar
 * créditos (/api/voice-previews/elev2/<voz>).
 * Envío PJ-2: antes había sólo 12 por error; se completó la lista.
 * Si cambia el manifest, el test elevenVoices.test.js avisa.
 */
export const ELEVEN_VOICES = [
  'Rachel', 'Drew', 'Clyde', 'Paul', 'Aria', 'Domi', 'Dave', 'Roger', 'Fin',
  'Sarah', 'James', 'Jane', 'Juniper', 'Arabella', 'Hope', 'Bradford',
  'Reginald', 'Gaming', 'Austin', 'Kuon', 'Blondie', 'Priyanka', 'Alexandra',
  'Monika', 'Mark', 'Grimblewood',
];

export const canPreview = (voice) => (voice?.provider || 'elevenlabs') === 'elevenlabs'
  && ELEVEN_VOICES.includes(voice?.voice);

/** Texto corto de compatibilidad para el campo `voice` de la marca. */
export const voiceText = (voices) => (voices || []).filter((v) => v?.voice)
  .map((v) => `${v.voice} · ElevenLabs`).join(' / ');

export default ELEVEN_VOICES;
